import React, { memo, useMemo } from 'react';
import cx from 'clsx';

import { IconVoteStar, IconVoteStarSolid } from '@/assets/proposals';
import { HelperTooltip } from '@/components';

import style from './index.module.scss';

export const RateStar = memo(
  ({ count = 5, rate = 0, className }: { count?: number; rate?: number; className?: string }) => {
    const _rate = useMemo(() => (rate > count ? count : rate > 0 ? rate : 0), [count, rate]);

    const solidWidth = useMemo(
      () => ({ width: count ? `${(_rate / count) * 100}%` : 0 }),
      [_rate, count],
    );

    return (
      <HelperTooltip
        title={
          rate >= 1
            ? `DeBank's quality rating for this proposal is ${rate}`
            : `This proposal doesn't hold significant value`
        }>
        <div className={cx(style.rateStar, className)}>
          {Array(count)
            .fill(0)
            .map((_, i) => (
              <IconVoteStar key={i} className={style.icon} />
            ))}
          <div className={style.rateStarSolid} style={solidWidth}>
            {Array(count)
              .fill(0)
              .map((_, i) => (
                <IconVoteStarSolid key={i} className={style.icon} />
              ))}
          </div>
        </div>
      </HelperTooltip>
    );
  },
);
